// components/BrandFooter/dummy.ts — data fallback footer saat brand_settings kosong
import type { BusinessInfo } from '../../types';

export const DUMMY = {
    // address SENGAJA tidak ada fallback dummy — alamat kosong lebih baik disembunyikan
    // daripada tampilkan alamat karangan ke customer (lihat FooterContent.tsx).
    email: (slug: string) => `cs@${slug}.id`,
    phone: '0812-3456-7890',
    hours: 'Senin - Sabtu, 08.00 - 17.00 WIB',
    policies: {
        returnPolicy: 'Produk dapat dikembalikan maksimal 7 hari setelah barang diterima dalam kondisi belum dipakai, lengkap dengan kemasan asli. Dana dikembalikan setelah barang kami terima dan periksa.',
        shippingPolicy: 'Pesanan diproses maksimal 1x24 jam pada hari kerja. Pengiriman menggunakan ekspedisi terpercaya dengan estimasi 2-5 hari kerja tergantung lokasi.',
        terms: 'Harga dan ketersediaan produk dapat berubah sewaktu-waktu. Pesanan yang sudah diproses tidak dapat dibatalkan sepihak. Untuk bantuan hubungi layanan CS kami.',
        privacyPolicy: 'Data pribadi Anda hanya digunakan untuk memproses pesanan dan pengiriman, tidak dibagikan kepada pihak ketiga di luar keperluan layanan.',
    } as BusinessInfo,
};
